/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurableParameterDto1 } from './ConfigurableParameterDto1';
import {
    ConfigurableParameterDto1FromJSON,
    ConfigurableParameterDto1FromJSONTyped,
    ConfigurableParameterDto1ToJSON,
    ConfigurableParameterDto1ToJSONTyped,
} from './ConfigurableParameterDto1';

/**
 * 
 * @export
 * @interface GuaranteeDto1Deductible
 */
export interface GuaranteeDto1Deductible {
    /**
     * 
     * @type {string}
     * @memberof GuaranteeDto1Deductible
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeDto1Deductible
     */
    idVariableValue: string;
    /**
     * 
     * @type {ConfigurableParameterDto1}
     * @memberof GuaranteeDto1Deductible
     */
    parameters: ConfigurableParameterDto1;
    /**
     * 
     * @type {number}
     * @memberof GuaranteeDto1Deductible
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof GuaranteeDto1Deductible
     */
    warningMessage?: string;
}

/**
 * Check if a given object implements the GuaranteeDto1Deductible interface.
 */
export function instanceOfGuaranteeDto1Deductible(value: object): value is GuaranteeDto1Deductible {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('idVariableValue' in value) || value['idVariableValue'] === undefined) return false;
    if (!('parameters' in value) || value['parameters'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function GuaranteeDto1DeductibleFromJSON(json: any): GuaranteeDto1Deductible {
    return GuaranteeDto1DeductibleFromJSONTyped(json, false);
}

export function GuaranteeDto1DeductibleFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuaranteeDto1Deductible {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'idVariableValue': json['idVariableValue'],
        'parameters': ConfigurableParameterDto1FromJSON(json['parameters']),
        'value': json['value'],
        'warningMessage': json['warningMessage'] == null ? undefined : json['warningMessage'],
    };
}

export function GuaranteeDto1DeductibleToJSON(json: any): GuaranteeDto1Deductible {
    return GuaranteeDto1DeductibleToJSONTyped(json, false);
}

export function GuaranteeDto1DeductibleToJSONTyped(value?: GuaranteeDto1Deductible | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'idVariableValue': value['idVariableValue'],
        'parameters': ConfigurableParameterDto1ToJSON(value['parameters']),
        'value': value['value'],
        'warningMessage': value['warningMessage'],
    };
}

